import React from 'react';
import PropTypes from 'prop-types';
import css from './DateOption.css';
import Icon from 'SF/MaterialIcon';

export default class DateOption extends React.Component {


  render() {    
    return (      
      <div className={css['container']}>

        <div onClick={this.props.onStartDateClick} >
          <input type="text"  aria-label="Start Date in m m hyphen d d hyphen y y y y format" value={this.props.startDate} onChange={this.props.onStartDateChange} onBlur={this.props.onDatesBlur} />
        </div>
        <div className={css['arrow']}><Icon icon="arrow_forward" /></div>
        <div onClick={this.props.onEndDateClick} >
          <input type="text" aria-label="End Date in m m hyphen d d hyphen y y y y format" onChange={this.props.onEndDateChange} value={this.props.endDate}  onBlur={this.props.onDatesBlur} />
        </div>
      </div>        
    );
  }
}

DateOption.propTypes = {
  startDate: PropTypes.string.isRequired,
  endDate: PropTypes.string.isRequired,
  onStartDateClick: PropTypes.func.isRequired,
  onEndDateClick: PropTypes.func.isRequired,
  onDatesBlur: PropTypes.func.isRequired,
  onStartDateChange: PropTypes.func.isRequired,
  onEndDateChange: PropTypes.func.isRequired
};
